import Model, { attr } from '@ember-data/model';

export default class DudaSsoLinkModel extends Model {
  @attr('string') link!: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'duda-sso-link': DudaSsoLinkModel;
  }
}
